<template>
  <div class="advanced-settings">
    <h1>{{ parseTranslation(SURVEY_ADVANCED_SETTINGS) }}</h1>

    <div class="advanced-options-rendered">
      <div v-for="(advancedOption, index) in optionsToRender()" :key="advancedOption">
        <component
          :is="getComponent(surveyAdvancedOptionsToRenderConfig[advancedOption].type)"
          :id="`survey-options-${index}`"
          :advanced_option="advancedOption"
        />

        <component
          :is="getCustomComponent(advancedOption)"
          :id="`survey-custom-option-${index}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Checkbox from './inputs/Checkbox'

import RandomByTags from './custom/RandomByTags'

import { surveyAdvancedOptionsToRenderConfig } from './surveyAdvancedOptions'

import * as translationIndex from './index.translations'

const { default: translations, ...translationKeys } = translationIndex

export default {
  name: 'surveyAdvancedSettingsRenderer',

  components: { Checkbox, RandomByTags },

  data() {
    return {
      translations,
      ...translationKeys,
      surveyAdvancedOptionsToRenderConfig,
    }
  },

  computed: {
    ...mapGetters(['survey']),
  },

  methods: {
    optionsToRender() {
      return Object.keys(surveyAdvancedOptionsToRenderConfig).filter(advancedOption =>
        surveyAdvancedOptionsToRenderConfig[advancedOption]?.shouldDisplayChecker
          ? surveyAdvancedOptionsToRenderConfig[advancedOption]?.shouldDisplayChecker(
              this.survey,
            )
          : true,
      )
    },

    getComponent(type) {
      switch (type) {
        case 'boolean':
          return 'Checkbox'

        default:
          return console.error(
            `${type} ${this.translations[this.language][this.DEFAULT_SWITCH]}`,
          )
      }
    },

    getCustomComponent(option) {
      const { hasCustomRenderer } = surveyAdvancedOptionsToRenderConfig[option]

      if (!hasCustomRenderer) return null

      switch (option) {
        case 'randomize_by_tags':
          return 'RandomByTags'

        default:
          return console.error(`Custom component for ${option} not found`)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  @include tipography(18);
  text-transform: uppercase;
}

.advanced-options-rendered {
  margin: 25px 0;
}

.light {
  h1 {
    color: $main;
  }
}
</style>
